import FormConfig from "./formConfig.js";
import { fun_PostAction } from "@/api/index";
import ConstructionChoose from "../../components/constructionChooseDialog/index.vue";
import AgencyCorpRecordsChoose from "../../components/agencyCorpRecordsChoose/index.vue";
// 引入附件上传页面
import CorpPictureinfor from '../../../components/pictureinfor/index.vue';
// 引入附件上传页面
import AgencyPictureinfor from '../../../components/pictureinfor/index.vue';
// 引入招标登记确认弹窗
import BiddingRegistrationVerifyDialog from '../../components/biddingRegistrationVerifyDialog/index.vue';
// 招标代理备案页面
import BiddingAgencyRecord from "@/views/page/biddingScheme/biddingAgencyRecord/details/index.vue";
// 核验记录
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: sessionStorage.getItem("workbenchMenu"),
      // 判断返回切换的tab
      activeName: sessionStorage.getItem("activeName"),
      // 全局加载框
      fullLoading: null,
      // 招标代理备案详情
      bidDialog: false,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "项目信息（一）",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          icon: true,
          formList: FormConfig.projectInformation(),
        },
        {
          name: "项目信息（二）",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          icon: true,
          formList: FormConfig.projectInformationTwo(),
        },
        {
          name: "招标信息",
          isSave: false,
          isActive: true,
          icon: true,
          formList: FormConfig.biddingInformation(),
        },
        {
          name: "其他要求",
          isSave: false,
          isActive: true,
          formList: FormConfig.otherRequirements(),
        },
      ],
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        constructionNo: null, // 报建编号
        agencyId: null, // 招标代理备案编号
        agencyMark: null, // 代理内容
        prjName: null, // 报建项目名称
        tenderPrjName: null, // 招标项目名称
        tenderClassNum: null, // 招标类别
        tenderClassName: null, // 招标类别名称
        tenderContentNum: null, // 招标内容
        tenderContentName: null, // 招标内容名称
        tenderTypeNum: null, // 招标方式
        tenderTypeName: null, // 招标方式名称
        tenderMethod: null, // 招标组织形式
        tenderProjectType: null, //  招标项目类型
        tenderProjectTypeName: null, //  招标项目类型名称
        tenderPrjIndustriesType: null, //  招标项目行业分类编码
        sectionQuantity: null, //  标段数/采购包
        prequalificationType: null, //  对投标人资格审查方式
        prequalificationTypeName: null, //  对投标人资格审查方式名称
        prequalificationShape: null, //  资格预审方式
        prequalificationMethod: null, //  资格预审办法
        prequalificationMethodName: null, //  资格预审办法名称
        fundsSources: null, //  资格预审办法
        figureReviewNo: null, //  图审合格书编号
        censorCorpName: null, //  施工图审查机构名称
        censorCorpCode: null, //  施工图审查机构社会信用代码
        allInvest: null, //  本次招标工程投资额
        plannedPeriod: undefined, //  计划工期
        structureArea: null, //  建筑面积
        noteNumber: null, //  立项批准文号
        approvalName: null, //  项目审批文件名称
        approvalAuthority: null, //  项目审批单位
        noteDate: null, //  立项批准日期
        totalNumberBuildings: null, //  单体总栋数
        evaluationMethod: null, //  评标办法
        evaluationMethodName: null, //  评标办法名称
        ebsFlag: null, //  是否电子标
        isLight: null, //  是否路灯/亮化项目
        isNeedPm: null, //  是否需要项目负责人/总监
        isNeedPmName: null, //  是否需要项目负责人/总监名称
        regulators: null, //  行政监督部门
        regulatorsName: null, //  行政监督部门名称
        tenderContentDescription: null, //  招标内容说明
        qualityRequirement: null, //  质量要求
        fundImplementation: null, //  资金落实情况
        fundingSource: null, //  资金性质
        fundingSourceName: null, //  资金性质名称
        projectVacancyRegistration: null, //  项目容缺登记
        projectVacancyRegistrationName: null, //  项目容缺登记名称
        specialCaseDescription: null, //  特殊情况说明
        tenderCorpId: null, //  招标人
        tenderCorpName: null, //  招标人
        tenderLinkMan: null, //  招标联系人
        tenderLinkPhone: null, //  招标联系人手机
        agencyCorpName: null, //  招标代理
        agencyLinkMan: null, //  招标代理联系人
        agencyLinkPhone: null, //  招标代理手机
        econTender: null, //  勘察招标
        econCorpName: null, //  勘察中标单位
        econCorpCode: null, //  勘察单位社会信用代码
        designTender: null, //  设计招标
        designCorpName: null, //  设计中标单位
        designCorpCode: null, //  设计单位社会信用代码
        superTender: null, //  监理招标
        superCorpName: null, //  监理中标单位
        superCorpCode: null, //  监理单位社会信用代码
        controlledPriceCorpName: null, //  招标控制价/标底价编制单位
        controlledPriceCorpCode: null, //  编制单位社会信用代码
        controlledPriceCorpLevel: null, //  编制单位资质等级
        isUnionCorpEnroll: null, //  是否允许联合体下载
        isUnionCorpEnrollName: null, //  是否允许联合体下载名称
        isUnionTender: null, //  招标单位是否联合体
        isUnionTenderName: null, //  招标单位是否联合体名称
        isUnionAgency: null, //  招标代理是否联合体
        nonstateInvestmentFlag: null, //  是否国有投资
        associationRequirement: null, //  联合体投标其它要求
        reconnaissance: null, //  是否组织踏勘
        reconnaissanceDate: null, //  踏勘时间
        reconnaissanceLocation: null, //  踏勘地点
        dissentDepartmentName: null, //  异议受理信息
        dissentDepartmentAddress: null, //  异议受理部门地址
        dissentDepartmentLinkMan: null, //  异议受理部门联系人
        dissentDepartmentLink: null, //  异议受理部门联系人手机
        dissentPostalCode: null, //  异议受理部门邮政编码
        dissentDepartmentEmail: null, //  异议受理部门电子邮箱
        otherRequirememts: null, //  其他要求
        description: null, //  备注
        isCancel: null, //  是否作废
        cancelDate: null, //  作废时间
        cancelMark: null, //  作废原因
        isGroup: null, //  是否地铁项目
        lockNo: null, //  锁编号
        digitalSignature: null, //  数字签名
        tenderOpinion: null, //  招标人意见
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        constructionNo: null, // 报建编号
        agencyId: null, // 招标代理备案编号
        agencyMark: null, // 代理内容
        prjName: null, // 报建项目名称
        tenderPrjName: null, // 招标项目名称
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        tenderTypeNum: null, // 招标方式
        tenderMethod: null, // 招标组织形式
        tenderProjectType: null, //  招标项目类型
        tenderProjectTypeName: null, //  招标项目类型名称
        tenderProjectIndustriesType: null, //  招标项目行业分类编码
        sectionQuantity: null, //  标段数/采购包
        prequalificationType: null, //  对投标人资格审查方式
        prequalificationShape: null, //  资格预审方式
        prequalificationMethod: null, //  资格预审办法
        prequalificationMethodName: null, //  资格预审办法名称
        fundsSources: null, //  资格预审办法
        figureReviewNo: null, //  图审合格书编号
        censorCorpName: null, //  施工图审查机构名称
        censorCorpCode: null, //  施工图审查机构社会信用代码
        allInvest: null, //  本次招标工程投资额
        plannedPeriod: null, //  计划工期
        structureArea: null, //  建筑面积
        noteNumber: null, //  立项批准文号
        approvalName: null, //  项目审批文件名称
        approvalAuthority: null, //  项目审批单位
        noteDate: null, //  立项批准日期
        totalNumberBuildings: null, //  单体总栋数
        evaluationMethod: null, //  评标办法
        ebsFlag: null, //  是否电子标
        isLight: null, //  是否路灯/亮化项目
        isNeedPm: null, //  是否需要项目负责人/总监
        regulators: null, //  行政监督部门
        tenderContentDescription: null, //  招标内容说明
        qualityRequirement: null, //  质量要求
        fundImplementation: null, //  资金落实情况
        fundingSource: null, //  资金性质
        projectVacancyRegistration: null, //  项目容缺登记
        specialCaseDescription: null, //  特殊情况说明
        tenderCorpName: null, //  招标人
        tenderLinkMan: null, //  招标联系人
        tenderLinkPhone: null, //  招标联系人手机
        agencyCorpName: null, //  招标代理
        agencyLinkMan: null, //  招标代理联系人
        agencyLinkPhone: null, //  招标代理手机
        econTender: null, //  勘察招标
        econCorpName: null, //  勘察中标单位
        econCorpCode: null, //  勘察单位社会信用代码
        designTender: null, //  设计招标
        designCorpName: null, //  设计中标单位
        designCorpCode: null, //  设计单位社会信用代码
        superTender: null, //  监理招标
        superCorpName: null, //  监理中标单位
        superCorpCode: null, //  监理单位社会信用代码
        controlledPriceCorpName: null, //  招标控制价/标底价编制单位
        controlledPriceCorpCode: null, //  编制单位社会信用代码
        controlledPriceCorpLevel: null, //  编制单位资质等级
        isUnionCorpEnroll: null, //  是否允许联合体下载
        isUnionTender: null, //  招标单位是否联合体
        isUnionAgency: null, //  招标代理是否联合体
        nonstateInvestmentFlag: null, //  是否国有投资
        associationRequirement: null, //  联合体投标其它要求
        reconnaissance: null, //  是否组织踏勘
        reconnaissanceDate: null, //  踏勘时间
        reconnaissanceLocation: null, //  踏勘地点
        dissentDepartmentName: null, //  异议受理信息
        dissentDepartmentAddress: null, //  异议受理部门地址
        dissentDepartmentLinkMan: null, //  异议受理部门联系人
        dissentDepartmentLink: null, //  异议受理部门联系人手机
        dissentPostalCode: null, //  异议受理部门邮政编码
        dissentDepartmentEmail: null, //  异议受理部门电子邮箱
        otherRequirememts: null, //  其他要求
        description: null, //  备注
        isCancel: null, //  是否作废
        cancelDate: null, //  作废时间
        cancelMark: null, //  作废原因
        isGroup: null, //  是否地铁项目
        state: null, //  状态
      },
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null, // 判断当前时提交还是退还至招标代理
      },
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单配置
      formConfigListTwo: FormConfig.projectInformationTwo(),
      // 主键
      id: null,
      // 操作类型
      controllerFlg: null,
      // 甲方确认标志
      isTenderSignature: null,
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      userType: sessionStorage.getItem("loginType"), // 用户类型
    };
  },

  computed: {

  },

  // 注册组件
  components: {
    ConstructionChoose,
    CorpPictureinfor, // 附件页面
    AgencyPictureinfor,
    AgencyCorpRecordsChoose,
    BiddingAgencyRecord,
    BiddingRegistrationVerifyDialog,
    AuditHistoryRecord, // 历史核验记录
  },
  // 接收来自父组件的数据
  props: {
    // 用于判断是否为子组件
    isComponent: {
      type: Boolean,
      default: false
    },
  },
   // 模板编译前
   created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
  },
  // 模板编译完成
  mounted() {

  },
  // 自定义方法
  methods: {
    /**
     * 打开时调用
     */
    fun_Open(){
      // 设置招标样式
      this.fun_ConstructionStyle();
      // 设置招标类别样式
      this.fun_GetTenderContentNumStyle();
      // 设置资格预审样式
      this.fun_GetPrequalificationTypeStyle();
      // 设置是否联合体样式
      this.fun_GetIsUnionCorpEnrollStyle();
      // 调用招标人和监管部门管理接口
      this.fun_GetCorpRegulators();
      // 调用电子标样式
      this.fun_GetEbsFlagStyle();
      // 如果是详情
      if (this.controllerFlg === 'detail') {
        // 遍历
        this.formConfigList.map(item => {
          // 遍历
          item.formConfigList.map(e => {
            // 禁止输入
            e.disabled = true;
            // 如果评标办法
            if (e.value == 'evaluationMethod'){
              // 查询
              e.queryParams = {
                url: "/dataDictionaryEntries/DictionaryCombobox",
                zdid: "201511101429230008",
                zfbz: "1",
              }
            }
          })
        })
      }
      // 如果是招标人确认的场合
      if (this.tenderSignedForm.tenderSignedState == 'tj' && this.tenderSignedForm.isDeregulation != '1') {
        // 遍历
        this.formConfigList.map(item => {
          // 遍历
          item.formConfigList.map(e => {
            // 如果招标人意见
            if (e.value == 'tenderOpinion') {
              // 取消不可输入
              e.disabled = false;
            }
          })
        })
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading() {
      this.fullLoading = this.$loading({
        lock: true,
        text: "正在进行加载，请耐心等待...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 打开招标项目选择弹窗（自行招标）
     * @author shuhua
     */
    fun_ConstructionChoose() {
      // 打开弹框时调用
      this.$refs.constructionChoose.searchFlag = "2";
      // 打开弹窗
      this.$refs.constructionChoose.dialogVisible = true;
      // 请求接口
      this.$refs.constructionChoose.fun_GetList();
    },
    /**
     * 选择报建信息返回的方法
     * @author 任少杰
     */
    fun_ConstructionSelected(e) {
      this.form.constructionId = e.val.id;
      this.form.constructionNo = e.val.constructionNo;
      this.form.prjName = e.val.prjName;
      this.form.tenderPrjName = e.val.prjName;
      this.form.tenderMethod = '1';
      this.form.prjLargeClass = e.val.prjLargeClass;
      this.form.tenderCorpId = e.val.buildCorpId;
      this.form.tenderCorpName = e.val.buildCorpName;
      this.form.isAudit = e.val.isAudit;
      this.form.tenderLinkMan = '';
      this.form.tenderLinkPhone = '';
      this.form.agencyCorpName = '';
      this.form.agencyLinkMan = '';
      this.form.agencyLinkPhone = '';
      // 调用招标人和监管部门管理接口
      this.fun_GetCorpRegulators();
    },
    /**
     * 打开招标项目选择弹窗（委托招标）
     * @author shuhua
     */
    fun_AgencyCorpRecordsChoose() {
      // 打开弹窗
      this.$refs.agencyCorpRecordsChoose.dialogVisible = true;
      // 请求接口
      this.$refs.agencyCorpRecordsChoose.fun_GetList();
    },
    /**
     * 代理备案选择选择返回的方法
     * @author 任少杰
     */
    fun_AgencyCorpRecordsSelected(e) {
      this.form.constructionId = e.val.constructionId;
      this.form.constructionNo = e.val.constructionNo;
      this.form.agencyId = e.val.id;
      this.form.prjName = e.val.prjName;
      this.form.tenderPrjName = e.val.prjName;
      this.form.tenderMethod = '2';
      this.form.prjLargeClass = e.val.prjLargeClass;
      this.form.tenderCorpId = e.val.buildCorpId;
      this.form.tenderCorpName = e.val.prjbuildCorpName;
      this.form.tenderLinkMan = e.val.tenderLinkMan;
      this.form.tenderLinkPhone = e.val.tenderLinkPhone;
      this.form.agencyCorpName = e.val.agencyCorpName;
      this.form.agencyLinkMan = e.val.agencyLinkMan;
      this.form.agencyLinkPhone = e.val.agencyLinkPhone;
      this.form.agencyMark = e.val.agencyMark; // 代理备案内容
      // 招标人联系人不为空
      if (this.form.tenderLinkMan != "" && this.form.tenderLinkMan != null) {
        // 遍历
        this.formConfigList.map(item => {
          item.formConfigList.map(e => {
            // 如果是招标人联系人或者招标人联系电话
            if (e.value == 'tenderLinkMan' || e.value == 'tenderLinkPhone') {
              // 禁止输入
              e.disabled = true;
            }
          })
        })
      }
      // 招标代理联系人不为空
      if (this.form.agencyLinkMan != "" && this.form.agencyLinkMan != null) {
        // 遍历
        this.formConfigList.map(item => {
          item.formConfigList.map(e => {
            // 如果是招标代理联系人或者招标代理联系电话
            if (e.value == 'agencyLinkMan' || e.value == 'agencyLinkPhone') {
              // 禁止输入
              e.disabled = true;
            }
          })
        })
      }
      // 调用招标人和监管部门管理接口
      this.fun_GetCorpRegulators();
    },
    /**
     * 代理委托信息查看
     */
    fun_AgencyCorpRecordsCheck() {
      // 打开弹窗
      this.bidDialog = true;
      // 执行
      this.$nextTick(() => {
        // 隐藏顶部
        this.$refs.biddingAgencyRecord.workbenchMenu = true;
        // 招标登记表主键
        this.$refs.biddingAgencyRecord.id = this.form.agencyId;
        // 查看详情
        this.$refs.biddingAgencyRecord.controllerFlg = "detail";
        // 获取详情
        this.$refs.biddingAgencyRecord.fun_Details();
      });
    },
    /**
     * 招标人和监管部门管理接口
     * @author 任少杰
     */
    fun_GetCorpRegulators() {
      // 招标人，招标监管部门不为空
      if (this.form.tenderCorpId != "" && this.form.tenderCorpId != null && this.form.regulators != "" && this.form.regulators != null) {
        // 发起请求
        fun_PostAction("/corpRegulators/getCorpRegulators", {
          corpId: this.form.tenderCorpId,
          regulators: this.form.regulators,
        }).then(res => {
          // 结构res.data
          const { result } = res.data;
          // 请求成功
          if (result) {
            // 如果是详情
            if (this.controllerFlg != 'detail') {
              // 遍历
              this.formConfigList.map(item => {
                item.formConfigList.map(e => {
                  // 如果是是否电子标
                  if (e.value == 'ebsFlag') {
                    // 可以输入
                    e.disabled = false;
                  }
                })
              })
            }
          } else {
            // 设置电子标标志
            this.form.ebsFlag = "1";
            // 遍历
            this.formConfigList.map(item => {
              item.formConfigList.map(e => {
                // 如果是是否电子标
                if (e.value == 'ebsFlag') {
                  // 禁止输入
                  e.disabled = true;
                }
              })
            })
          }
        })
      }
    },
    /**
     * 清空项目信息
     */
    fun_CheanProject(){
      // 清空报建表主键
      this.form.constructionId = "";
      // 清空报建编号
      this.form.constructionNo = "";
      // 清空代理备案编号
      this.form.agencyId = "";
      // 清空报建项目名称
      this.form.prjName = "";
      // 清空招标项目名称
      this.form.tenderPrjName = "";
      // 清空代理内容
      this.form.agencyMark = "";
      // 清空招标组织形式
      this.form.tenderMethod = "";
      // 定义字段
      let arr = ["agencyFile"];
      // 删除字段
      this.formConfigList[0].formConfigList = this.formConfigList[0].formConfigList.filter(
        e => !arr.includes(e.value)
      );
    }, 
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i, arr) {
      // 声明name
      var arrName = "";
      // 遍历
      arr.map(arrItem=>{
        // 判断
        if (e === arrItem.value) {
          // 赋值
          arrName = arrItem.name;
        }
      })
      // 招标内容
      if(i === "tenderContentNum"){
        // 获取值
        this.form.tenderContentNum = e;
        // 判断选择的值
        if(e == '201603181125070012' || e == '201603181125220013' || e == '201603181125350014' || 
        e == '201603181128050019' || e == '201603181126230015' || e == '201603181128490021'){
          // 遍历流程
          this.stepsList.map(item=>{
            // 遍历流程表单
            item.formList.map(formList=>{
              // 遍历表单内容
              formList.formConfigList.map(formConfigList=>{
                // 判断是“需要项目负责人/总监”
                if(formConfigList.value === "isNeedPm"){
                  // 招标类别不是工程货物招标
                  if (this.form.tenderClassNum != "201510200928400009"){
                    // 需要项目负责人/总监默认为“是”
                    this.form.isNeedPm = "1";
                    // 禁用
                    formConfigList.disabled = true;
                    this.$set(formConfigList, "disabled", true);
                  }else{
                    // 不禁用
                    formConfigList.disabled = false;
                  }
                }
              })
            })
          })
          // 遍历表单内容
          this.formConfigList.map(item=>{
            item.formConfigList.map(formConfigList=>{
              // 判断是“需要项目负责人/总监”
              if(formConfigList.value === "isNeedPm"){
                // 招标类别不是工程货物招标
                if (this.form.tenderClassNum != "201510200928400009"){
                  // 需要项目负责人/总监默认为“是”
                  this.form.isNeedPm = "1";
                  // 禁用
                  formConfigList.disabled = true;
                  this.$set(formConfigList, "disabled", true);
                }else{
                  // 不禁用
                  formConfigList.disabled = false;
                }
              }
            })
          })
        }else{
          // 遍历流程
          this.stepsList.map(item=>{
            // 遍历流程表单
            item.formList.map(formList=>{
              // 遍历表单内容
              formList.formConfigList.map(formConfigList=>{
                // 判断是“需要项目负责人/总监”
                if(formConfigList.value === "isNeedPm"){
                  // 设置默认不禁用
                  formConfigList.disabled = false;
                }
              })
            })
          })
          // 遍历表单内容
          this.formConfigList.map(item=>{
            item.formConfigList.map(formConfigList=>{
              // 判断是“需要项目负责人/总监”
              if(formConfigList.value === "isNeedPm"){
                // 设置默认不禁用
                formConfigList.disabled = false;
              }
            })
          })
        }
      } 
      // 招标类别
      else if (i === "tenderClassNum") {
        // 赋值
        this.form.tenderClassNum = e;
        // 赋值
        this.form.tenderClassName = arrName;
        // 设置招标类别样式
        this.fun_GetTenderContentNumStyle();
        // 清空招标内容值
        this.form.tenderContentNum = null;
      } 
      // 招标监管部门
      else if (i == "regulators") {
        // 赋值
        this.form.regulators = e;
        // 赋值
        this.form.regulatorsName = arrName;
        // 调用招标人和监管部门管理接口
        this.fun_GetCorpRegulators();
      }
      // 对投标人资格审查方式
      else if (i == "prequalificationType"){
        // 赋值
        this.form.prequalificationType = e;
        // 赋值
        this.form.prequalificationTypeName = arrName;
        // 如果是资格预审
        if(e == '1'){
          // 清空资格预审办法
          this.form.prequalificationMethod = "";
          // 清空评标办法
          this.form.evaluationMethod = "";
          // 清空资格预审办法
          this.form.prequalificationMethodName = "";
          // 清空评标办法
          this.form.evaluationMethodName = "";
        }
        // 如果是资格后审
        else{
          // 清空评标办法
          this.form.evaluationMethod = "";
          // 清空评标办法
          this.form.evaluationMethodName = "";
          // 清空是否地铁项目
          this.form.isGroup = ""
        }
        // 设置资格预审样式
        this.fun_GetPrequalificationTypeStyle();
      }
      // 是否联合体下拉框
      else if (i == "isUnionCorpEnroll") {
        // 赋值
        this.form.isUnionCorpEnroll = e;
        // 赋值
        this.form.prequalificationTypeName = arrName;
        // 设置是否联合体样式
        this.fun_GetIsUnionCorpEnrollStyle();
      }
      // 招标单位是否联合体
      else if (i == "isUnionTender"){
        // 赋值
        this.form.isUnionTender = e;
        // 招标联合体设置
        this.fun_SerTenderUnion(e);
      }
      // 招标项目类型
      else if (i == "tenderProjectType") {
        // 赋值
        this.form.tenderProjectType = e;
        // 赋值
        this.form.tenderProjectTypeName = arrName;
      }
      // 资格预审办法
      else if (i == "prequalificationMethod") {
        // 赋值
        this.form.prequalificationMethod = e;
        // 赋值
        this.form.prequalificationMethodName = arrName;
      }
      // 评标办法
      else if (i == "evaluationMethod") {
        // 赋值
        this.form.evaluationMethod = e;
        // 赋值
        this.form.evaluationMethodName = arrName;
      }
      // 资金性质
      else if (i == "fundingSource") {
        // 赋值
        this.form.fundingSource = e;
        // 赋值
        this.form.fundingSourceName = arrName;
      }
      // 是否允许联合体投标报名
      else if (i == "isUnionCorpEnroll") {
        // 赋值
        this.form.isUnionCorpEnroll = e;
        // 赋值
        this.form.isUnionCorpEnrollName = arrName;
      }
      // 招标单位是否联合体
      else if (i == "isUnionTender") {
        // 赋值
        this.form.isUnionTender = e;
        // 赋值
        this.form.isUnionTenderName = arrName;
      }
      // 项目容缺登记
      else if (i == "projectVacancyRegistration") {
        // 赋值
        this.form.projectVacancyRegistration = e;
        // 赋值
        this.form.projectVacancyRegistrationName = arrName;
      }
      // 招标方式
      else if (i == "tenderTypeNum") {
        // 赋值
        this.form.tenderTypeNum = e;
        // 赋值
        this.form.tenderTypeName = arrName;
      }
      else {
        // 赋值
        this.form[i] = e;
      }
    },
    /**
    * 甲方确认
    */
    fun_GetTenderSignature(data) {
      // 赋值招标人意见
      this.form.tenderOpinion = data.tenderOpinion;
      // 赋值招标人意见
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion;
      // 赋值招标人签章确认编号
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId;
      // 赋值招标人签章状态
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState;
      // 赋值添加标记
      this.tenderSignedForm.isDeregulation = data.isDeregulation;
      // 赋值招标人盖章确认的招标监管部门
      this.tenderSignedForm.esRegulators = data.esRegulators;
      // 赋值招标人盖章确认的招标监管流程
      this.tenderSignedForm.esProcessType = data.esProcessType;
      // 赋值招标人盖章确认权限编号
      this.tenderSignedForm.esInvitationId = data.esInvitationId;
      // 赋值招标人盖章的数字签名
      this.tenderSignedForm.tenderStampData = data.tenderStampData;
      // 表名
      this.tenderSignedForm.table = data.model.tableName;
      // 字段
      this.tenderSignedForm.key = data.model.keyState;
      // 数据编号
      this.tenderSignedForm.recordNumber = data.model.id;
    },
    /**
     * 招标样式修改
     */
    fun_ConstructionStyle(){
      // 委托招标或者招标代理
      if (this.form.tenderMethod == '2' || (this.userType == '201904241346560059' && (this.form.tenderMethod == '' || this.form.tenderMethod == null))) {
        // 遍历
        this.formConfigList.map(element => {
          // 自行招标
          if (element.title === "自行招标") {
            // 重新赋值
            element.title = "委托代理招标";
            // 重新设置页面
            element.formConfigList = [
              {
                label: "项目编号：",
                value: "constructionNo",
                type: "input",
                disabled: true,
                width: "100%;"
              },
              {
                label: "招标代理备案编号：",
                value: "agencyId",
                type: "slot",
                slotName: "agencyId",
                disabled: true,
                width: "100%;"
              },
              {
                label: "代理内容：",
                value: "agencyMark",
                type: "textarea",
                class: "formTextarea",
                disabled: true,
                width: "100%;"
              },
              // {
              //   label: "代理合同（协议）扫描件：",
              //   type: "slot",
              //   slotName: "agencyFile",
              // },
            ]
          }
        });
      }
      // 如果是自行招标
      else{
        // 遍历
        this.formConfigList.map(itme => {
          // 遍历
          itme.formConfigList.map(e => {
            // 如果是招标代理联系人或者招标代理手机
            if (e.value === "agencyLinkMan" || e.value === "agencyLinkPhone") {
              // 禁止输入
              e.disabled = true;
            }
          })
        });
      }
    },
    /**
     * 招标类别样式
     */
    fun_GetTenderContentNumStyle(){
      // 招标类别不为空
      if (this.form.tenderClassNum != '' && this.form.tenderClassNum != null){
        // 遍历
        this.formConfigList.map(itme => {
          // 遍历
          itme.formConfigList.map(e => {
            // 如果是招标内容
            if (e.value === "tenderContentNum") {
              // 修改下拉框请求参数，重新赋值
              e.queryParams = {
                url: "/tenderContent/TenderContentCombobox",
                tenderClassNum: this.form.tenderClassNum,
                flag: "1"
              }
            }
          })  
        });
      }
    },
    /**
     * 设置资格预审样式
     */
    fun_GetPrequalificationTypeStyle(){
      // 如果是资格预审
      if (this.form.prequalificationType == '1'){
        // 定义字段
        let arr = ["evaluationMethod"];
        // 遍历
        this.formConfigList.map(item => {
          if (item.name == '2' && item.title == '项目信息') {
            // 删除字段
            item.formConfigList = item.formConfigList.filter(
              e => !arr.includes(e.value)
            );
          }
        });
        // 遍历
        this.formConfigList.map(item => {
          // 遍历
          item.formConfigList.map(e => {
            // 如果是资格预审办法
            if (e.value == 'prequalificationMethod') {
              // 可以输入
              e.disabled = false;
              // 设置不为空
              e.rule.required = true;
            }
          })
        })
        // 是否存在是否地铁项目
        let isGroupRtn = false;
        // 设置下标
        let num = 0;
        // 遍历
        this.formConfigList.map(item => {
          // 验证
          if (item.name == '3' && item.title == '项目信息') {
            // 遍历
            item.formConfigList.map((e, index) => {
              // 如果时是否项目经理
              if (e.value == 'isNeedPm'){
                // 获取下标
                num = index+1;
              }
              // 如果是是否地铁项目
              if (e.value == 'isGroup') {
                // 设置true
                isGroupRtn = true;
              }
            })
          }
        })
        // 如果不存在是否地铁项目
        if (!isGroupRtn) {
          // 遍历
          this.formConfigList.map(item => {
            // 验证
            if (item.name == '3' && item.title == '项目信息') {
              // 截取
              item.formConfigList.splice(num, 0, {
                label: "是否地铁项目：",
                value: "isGroup",
                type: "select",
                clearable: true,
                tip: "(若选择是，评审时将不进行分组评审)",
                optionData: [{
                    name: "否",
                    value: "1"
                  },
                  {
                    name: "是",
                    value: "0"
                  },
                ],
                rule: {
                  required: true,
                  message: "该输入项不能为空",
                  trigger: "blur"
                },
              });
            }
          }); 
        }
      }
      // 如果是资格后审
      else{
        // 清空选择的资格预审办法
        this.form.prequalificationMethod = null;
        // 定义字段
        let arr = ["isGroup"];
        // 遍历
        this.formConfigList.map(item => {
          if (item.name == '3' && item.title == '项目信息') {
            // 删除字段
            item.formConfigList = item.formConfigList.filter(
              e => !arr.includes(e.value)
            );
          }
        });
        // 是否存在评标办法
        let evaluationMethodRtn = false;
        // 遍历
        this.formConfigList.map(item => {
          // 如果时项目信息
          if (item.name == '2') {
            // 遍历
            item.formConfigList.map(e => {
              // 如果是资格预审办法
              if (e.value == 'prequalificationMethod') {
                // 禁止输入
                e.disabled = true;
                // 取消不为空
                e.rule.required = false;
              }
              // 如果是评标办法
              else if (e.value == 'evaluationMethod') {
                // 设置true
                evaluationMethodRtn = true;
              }
            })
          }
        })
        // 如果不存在评标办法
        if (!evaluationMethodRtn) {
          // 遍历
          this.formConfigList.map(item => {
            // 如果时项目信息
            if (item.name == '2' && item.title == '项目信息') {
              // 截取
              item.formConfigList.splice(20, 0, 
                {
                  label: "评标办法：",
                  value: "evaluationMethod",
                  type: "select",
                  clearable: true,
                  queryParams: {
                    url: "/dataDictionaryEntries/DictionaryCombobox",
                    zdid: "201511101429230008"
                  },
                  rule: {
                    required: true,
                    message: "该输入项不能为空",
                    trigger: "blur"
                  },
                }, 
              )
            }  
          })
        }
      }
    },
    /**
     * 设置是否联合体样式
     */
    fun_GetIsUnionCorpEnrollStyle() {
      // 如果不是详情
      if (this.controllerFlg != "detail"){
        // 如果是联合体
        if (this.form.isUnionCorpEnroll == "1") {
          // 遍历
          this.formConfigList.map(item => {
            item.formConfigList.map(e => {
              // 如果是联合体投标其它要求
              if (e.value == 'associationRequirement') {
                // 可以输入
                e.disabled = false;
              }
            })
          })
        }
        // 如果不是联合体
        else {
          // 遍历
          this.formConfigList.map(item => {
            item.formConfigList.map(e => {
              // 如果是联合体投标其它要求
              if (e.value == 'associationRequirement') {
                // 禁止输入
                e.disabled = true;
              }
            })
          })
        }
      }
    },  
    /**
     * 设置电子标样式
     */
    fun_GetEbsFlagStyle(){
      // 如果是新增
      if (this.controllerFlg == "insert") {
        // 默认电子标
        this.form.ebsFlag = "1";
        // 遍历
        this.formConfigList.map(item => {
          item.formConfigList.map(e => {
            // 如果电子标
            if (e.value == 'ebsFlag') {
              // 禁止输入
              e.disabled = true;
            }
          })
        })
      }
    },
    /**
    * 代理合同（ 协议） 扫描件
    */
    fun_GetAgencyPictureinfor(type) {
      // 备案编号不为空
      if (this.form.agencyId != '' && this.form.agencyId != null){
        // 打开弹窗
        this.$refs.agencyPictureinfor.dialogVisible = true;
        // 打开弹框时调用
        this.$refs.agencyPictureinfor.fun_GetOpen();
      }else{
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("请选择招标代理备案信息！");
        return false;
      }
    },
    /**
     * 招标单位是否联合体设置 
     */
    fun_SerTenderUnion(e){
      // 如果是联合体
      if(e == '1'){
        // 调用主页面设置招标单位联合体方法
        this.$parent.fun_SerTenderUnion(this.form.tenderCorpId, this.form.tenderCorpName);
      }
      // 如果不是联合体
      else{
        // 调用主页面设置招标单位联合体方法
        this.$parent.fun_SerTenderUnion("", "");
      }
    },
    /**
     * 附件上传
     */
    fun_GetCorpPictureinfor(type){
      // 打开弹窗
      this.$refs.corpPictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.corpPictureinfor.fun_GetOpen();
    },
    /**
    * 甲方确认
    */
    fun_TenderStamp(e) {
      // 调用主页面提交方法
      this.$parent.fun_TenderStamp(e);
    },
    /**
    * 提交方法
    * @author liutong
    */
    fun_Submit(state, val) {
      // 调用主页面提交方法
      this.$parent.fun_Submit(state, val);
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData(){
      // 遍历流程数据
      this.stepsList.map((item,index)=>{
        // 遍历表单内容
        item.formList.map(formList=>{
          // 遍历表单字段
          formList.formConfigList.map(form=>{
            // 判断是否填写内容
            if(this.form[form.value]){
              // 改变状态
              item.isSave = true;
            }else{
              // 赋值下标
              // this.stepsActive = index;
              // 获取表单数据
              // this.formConfigList = item.formList;
            }
          })
        })
      })
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData(){
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item=>{
        // 判断是否存在表单
        if(item.formConfigList && item.formConfigList.length > 0) formArr.push(...item.formConfigList);
      })
      // 判断当前表单
      for(var i = 0; i < formArr.length;i++){
        // 判断字段是否填写值
        if(this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index){
      // 判断是否填写内容
      if(this.fun_GetStepsIsData()){
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      }else{
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      if(this.controllerFlg != 'detail'){
        // 判断是否选择项目
        if(!this.form.prjName){
          // 错误提示
          this.$alert("请优先选择项目登记信息！", "warning");
          // 不再切换
          return false;
        }
        // 调用主页面保存方法
        this.$parent.fun_NextInUpd('bc');
      }
      // 赋值下标
      this.stepsActive = index;
      // 获取表单数据
      this.formConfigList = val.formList;
      // 设置样式
      this.fun_Open();
    },
    /**
     * 上一步
     */
    fun_GetLastStep(){
      // 判断是否填写内容
      if(this.fun_GetStepsIsData()){
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      }else{
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      if(this.controllerFlg != 'detail'){
        // 判断是否选择项目
        if(!this.form.prjName){
          // 错误提示
          this.$alert("请优先选择项目登记信息！", "warning");
          // 不再切换
          return false;
        }
        // 调用主页面保存方法
        this.$parent.fun_NextInUpd('bc');
      }
      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
      // 设置样式
      this.fun_Open();
    },
    /**
     * 下一步
     */
    fun_GetNextStep(){
      // 判断是否填写内容
      if(this.fun_GetStepsIsData()){
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = true;
      }else{
        // 修改状态用于前端显示
        this.stepsList[this.stepsActive].isSave = false;
      }
      if(this.controllerFlg != 'detail'){
        // 判断是否选择项目
        if(!this.form.prjName){
          // 错误提示
          this.$alert("请优先选择项目登记信息！", "warning");
          // 不再切换
          return false;
        }
        // 调用主页面保存方法
        this.$parent.fun_NextInUpd('bc');
      }
      this.stepsActive++;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
      // 设置样式
      this.fun_Open();
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 返回工作台
     */
    fun_BackStaff(){
      // 跳转工作台
      this.$router.push({path: "/staffWorkbench" });
    },
    // 打开核验记录
    fun_OpenAuditHistoryRecord(){
      // 调用父方法
      this.$parent.fun_OpenAuditHistoryRecord();
    }
  }
};
